<template>
  <div id="stashboard" :class="{loading: loading}">
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="loading" class="loading">
      <img :src="loadingGif" alt="loading"/>
    </div>
    <template v-else>
      <div class="title">
        {{ merchantNameDecoded }}
      </div>
      <div v-if="urlLogo" class="logo">
        <img :src="urlLogo" alt="logo" />
      </div>
      <div class="content shadow border-radius">
        <div v-if="urlImage" class="ads shadow border-radius" @click="clickedOnImage()" :style="{ backgroundImage: `url(${urlImage})` }"></div>
        <div class="body border-radius">
          <div v-html="formattedContent"></div>
          <div v-if="labelButton" @click="clickedOnButton()" class="button">
            {{ labelButton }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import linkifyHtml from 'linkifyjs/html'
  import loadingGif from 'passcode/loading.gif'

  export default {
    name: "Stashboard",

    props: {
      id: String,
      content: String,
      extensionType: String,
      merchantName: String,
      merchantWebsiteUrl: String,
      urlButton: String,
      urlImage: String,
      urlLogo: String
    },

    data() {
      return {
        loading: false,
        loadingGif,
        error: null,
      }
    },

    computed: {
      formattedContent(){
        const options = {
                nl2br: true
              },
              content = this.content

        return (content) ? linkifyHtml(content, options) : ""
      },

      labelButton(){
        const type = this.extensionType
        let label = ""

        if(type == "any_link") label = "see more"
        else if(type == "target_wallet") label = "view wallet"
        else if(!type && this.merchantWebsiteUrl) label = "shop online"
        else if(!!type) label = "view offer"

        return label
      },

      merchantNameDecoded(){
        return this.merchantName ? atob(this.merchantName) : ""
      }
    },

    methods: {
      clickedOnButton(){
        const url = this.urlButton ? this.urlButton : this.merchantWebsiteUrl

        if (url.startsWith('http://') || url.startsWith('https://')) {
          location.replace(url)
        } else {
          this.error = `Invalid "${this.labelButton}" URL. Please contact support.`
        }
      },

      clickedOnImage(){
        window.open(this.urlImage, '_blank')
      }
    },

    created(){
      /* BEGIN */
      /* This is a temporary solution for old campaign */
      /* Old campaign that does not have sms_content or extensions */
      /* This code will be removed later on */
      if(!this.extensionType & !this.content & !!this.urlButton) {
        this.loading = true
        location.replace(this.urlButton)
      }
      /* END */
      if(!this.merchantName){
        this.loading = true
        location.replace(`/passcode/${this.id}?f=true`)
      }
    }
  }
</script>
